import React from 'react';
import { WrenchIcon, UsersIcon, AwardIcon, TrendingUpIcon } from 'lucide-react';
export function About() {
  return <section id="about" className="relative py-24 overflow-hidden bg-gray-50" data-id="element-327">
      {/* Lighter Background Image */}
      <div className="absolute inset-0 w-full h-full" style={{
      backgroundImage: 'url(https://uploadthingy.s3.us-west-1.amazonaws.com/ieedrSacyiKmrX5boCqSMy/image.png)',
      backgroundSize: 'cover',
      backgroundPosition: 'center center',
      backgroundRepeat: 'no-repeat',
      backgroundAttachment: 'fixed',
      zIndex: 0,
      opacity: 0.15
    }} data-id="element-328"></div>

      {/* Content */}
      <div className="container mx-auto px-4 relative z-10" data-id="element-329">
        <div className="max-w-6xl mx-auto" data-id="element-330">
          {/* Logo Badge */}
          <div className="flex justify-center mb-12" data-id="element-331">
            <div className="relative" data-id="element-332">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/vgAD6BMFW6FPpPWQURJJHv/logo_black_bg.jpg" alt="Garrett Auto & Truck Service" className="w-64 h-auto rounded-lg shadow-2xl border-4 border-[#D4AF37]" data-id="element-333" />
            </div>
          </div>

          <h2 className="text-5xl font-bold text-gray-900 mb-6 text-center" data-id="element-334">
            About Garrett Auto & Truck Service
          </h2>

          <p className="text-2xl text-[#B1050B] text-center mb-16 font-medium" data-id="element-335">
            Serving Southeast Michigan Since 1958
          </p>

          {/* Main Content Grid */}
          <div className="grid lg:grid-cols-2 gap-12 mb-16" data-id="element-336">
            {/* Left Column - History */}
            <div className="space-y-6" data-id="element-337">
              <div className="bg-white p-8 rounded-lg border-l-4 border-[#B1050B] shadow-lg" data-id="element-338">
                <h3 className="text-2xl font-bold text-[#B1050B] mb-4 flex items-center" data-id="element-339">
                  <TrendingUpIcon size={28} className="mr-3" data-id="element-340" />
                  Our Heritage
                </h3>
                <div className="space-y-4 text-gray-700 text-lg leading-relaxed" data-id="element-341">
                  <p data-id="element-342">
                    Founded in <strong className="text-gray-900" data-id="element-343">1958</strong>{' '}
                    as a Standard Oil station at Halstead and Grand River, we've
                    been keeping Southeast Michigan moving for over six decades.
                  </p>
                  <p data-id="element-344">
                    In 1978, we moved to our current facility at 24445 Grand
                    River Avenue in Farmington Hills. From servicing farm
                    equipment when Ten Mile was still a dirt road to maintaining
                    corporate fleets today—we've grown with our community every
                    step of the way.
                  </p>
                </div>
              </div>
            </div>

            {/* Right Column - Expertise */}
            <div className="space-y-6" data-id="element-345">
              <div className="bg-white p-8 rounded-lg border-l-4 border-[#D4AF37] shadow-lg" data-id="element-346">
                <h3 className="text-2xl font-bold text-[#B1050B] mb-4 flex items-center" data-id="element-347">
                  <UsersIcon size={28} className="mr-3" data-id="element-348" />
                  Our Expert Team
                </h3>
                <div className="space-y-4 text-gray-700 text-lg leading-relaxed" data-id="element-349">
                  <p data-id="element-350">
                    <strong className="text-gray-900" data-id="element-351">
                      Licensed, certified mechanics
                    </strong>{' '}
                    with over 50 years of collective experience. From brake
                    service to complete engine overhauls—if it has wheels, we
                    can fix it.
                  </p>
                  <p data-id="element-352">
                    <strong className="text-gray-900" data-id="element-353">
                      Well known throughout Southeast Michigan
                    </strong>{' '}
                    for commercial truck expertise. Diesel or gas, passenger car
                    or heavy-duty fleet—our master mechanics keep your vehicles
                    running strong.
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Service Philosophy */}
          <div className="bg-white p-8 rounded-lg border-l-4 border-[#B1050B] mb-16 shadow-lg" data-id="element-354">
            <h3 className="text-2xl font-bold text-[#B1050B] mb-4 flex items-center" data-id="element-355">
              <WrenchIcon size={28} className="mr-3" data-id="element-356" />
              Our Service Philosophy
            </h3>
            <div className="space-y-4 text-gray-700 text-lg leading-relaxed" data-id="element-357">
              <p data-id="element-358">
                <strong className="text-gray-900" data-id="element-359">
                  We believe in preventative maintenance.
                </strong>{' '}
                Regular oil changes, filter replacements, and
                manufacturer-recommended services keep your vehicle running
                longer and save you money by preventing costly breakdowns.
              </p>
              <p data-id="element-360">
                From basic maintenance to complex repairs, passenger vehicles to
                commercial fleets—Garrett Auto & Truck Service has been
                Southeast Michigan's trusted choice for over 65 years.
              </p>
            </div>
          </div>

          {/* Stats Grid */}
          <div className="grid md:grid-cols-4 gap-6 mb-16" data-id="element-361">
            <div className="bg-[#B1050B] p-6 rounded-lg text-center border-2 border-[#D4AF37] shadow-lg" data-id="element-362">
              <div className="text-4xl font-bold text-white mb-2" data-id="element-363">65+</div>
              <div className="text-red-100 font-medium" data-id="element-364">Years in Business</div>
            </div>
            <div className="bg-[#B1050B] p-6 rounded-lg text-center border-2 border-[#D4AF37] shadow-lg" data-id="element-365">
              <div className="text-4xl font-bold text-white mb-2" data-id="element-366">50+</div>
              <div className="text-red-100 font-medium" data-id="element-367">Years Experience</div>
            </div>
            <div className="bg-[#B1050B] p-6 rounded-lg text-center border-2 border-[#D4AF37] shadow-lg" data-id="element-368">
              <div className="text-4xl font-bold text-white mb-2" data-id="element-369">100%</div>
              <div className="text-red-100 font-medium" data-id="element-370">Certified Techs</div>
            </div>
            <div className="bg-[#B1050B] p-6 rounded-lg text-center border-2 border-[#D4AF37] shadow-lg" data-id="element-371">
              <div className="text-4xl font-bold text-white mb-2" data-id="element-372">All</div>
              <div className="text-red-100 font-medium" data-id="element-373">Makes & Models</div>
            </div>
          </div>

          {/* Quality Promise */}
          <div className="bg-gradient-to-br from-[#B1050B] to-[#8A0408] p-10 rounded-lg shadow-2xl border-4 border-[#D4AF37]" data-id="element-374">
            <div className="flex items-center justify-center mb-6" data-id="element-375">
              <AwardIcon size={48} className="text-[#D4AF37] mr-4" data-id="element-376" />
              <h3 className="text-4xl font-bold text-white" data-id="element-377">
                Our Quality Promise
              </h3>
            </div>
            <div className="max-w-4xl mx-auto" data-id="element-378">
              <p className="text-white text-xl leading-relaxed text-center mb-6" data-id="element-379">
                Garrett Auto & Truck Service is here to serve you by performing
                the highest quality automotive & truck repairs at fair prices,
                using only proven materials of the highest quality.
              </p>
              <p className="text-red-100 text-xl leading-relaxed text-center mb-6" data-id="element-380">
                Our service is backed by our personal pledge of customer
                satisfaction. We will provide you, our customer, with
                outstanding professional courtesy and service.
              </p>
              <p className="text-white text-2xl font-bold text-center" data-id="element-381">
                And we will stand behind our workmanship.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}